import React, {useEffect, useState} from 'react'
import {
    Grid,
    Box,
    makeStyles,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Backdrop,
    CircularProgress
} from '@material-ui/core'

import {
    getDeviceId,
    getCurrentStep as _getCurrentStep,
    processCurrentStep,
    getBackStep,
} from '../services/api'

import {IUser, IDevice} from '../interfaces/model'
import {useHistory} from 'react-router-dom'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import BootstrapInput from './Common/BootstrapInput'
import SuhaBubble from "./Suha/SuhaBubbleSmall";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
        margin: 'auto',
        position: 'absolute',
        // top: '50%',
        // transform: 'translateY(-50%)',
        padding: '.5vh 3vw',
        minHeight: '100vh',
        minWidth: '100vw',
    },
    img: {
        maxHeight: '90vw',
    },
    container: {
        backgroundColor: theme.palette.primary.dark,
    },

    fullWidth: {
        width: '100%',
    },
    buttons: {
        display: 'flex',
        marginTop: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(3),
    },
    buttonBold: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        fontWeight: 'bold',
    },
    backButton: {
        fontSize: '1.5rem',
        width: '2em',
        height: '2em',
    },
    nextButton: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(2),
        // display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
        textTransform: "none"
    },
    selectedButton: {
        backgroundColor: '#256081',
        borderRadius: '2px',
        color: 'white',
        padding: "5px 5px",
        marginTop: theme.spacing(1),
        // display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
        textTransform: "none"
    },
    unselected: {
        color: '#256081',
        backgroundColor: 'white',
        borderRadius: '2px',
        padding: "5px 5px",
        marginTop: theme.spacing(1),
        // display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
        textTransform: "none"
    },
    text: {
        transform: 'none',
        fontWeight: 'normal',
        color: 'black',
        fontSize: '1.2rem',
        whiteSpace: 'pre-wrap',
    },
    bold: {
        fontWeight: 'bold',
        color: 'black',
        fontSize: '1.2rem',
        whiteSpace: 'pre-wrap',
    },
    italic: {
        color: 'black',
        fontSize: '1.2rem',
        whiteSpace: 'pre-wrap',
    },
    buttonGroup: {
        width: '100%',
        marginBottom: '1em',
    },
    logo: {
        maxWidth: '100%',
    },
    suha: {
        margin: '2vh',
        maxWidth: '33%',
    },
    answerButton: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(2),
        // display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
        textTransform: "none"
    },
    '&:hover': {
        color: 'white',
        backgroundColor: 'blue',
        borderColor: 'white',
        boxShadow: 'none',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    Link: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
        whiteSpace: 'pre',
    },
}))

interface StepperProps {
    user: IUser
    device: IDevice
}

interface IImage {
    tag: string
    text: string
    src: string
    style: string
}

interface Ip {
    tag: string
    text: string
    style: string
}

interface IButtons {
    id: string | null
    tag: string | null
    required: boolean
    style: string | null
    action: string | null
    buttons: IButton[]
}

interface IButton {
    title: string
    value: string
    selected: boolean
}

interface IDropdown {
    id: string | null
    options: IOption[]
    required: boolean
    style: string | null
    tag: string | null
}

interface IOption {
    title: string | null
    value: any | null
    order: number
    selected: boolean
}

interface ITextbox {
    action: string | null
    id: string
    required: boolean
    style: string | null
    tag: string | null
    value: any
}

export default function Stepper(props: StepperProps) {
    const classes = useStyles()
    const history = useHistory()
    const [data, setData] = useState<any>({})
    const [valid, setValid] = useState<boolean>(true)
    const [loading, setLoading] = useState<boolean>(false)
    // TODO clean this _state, setState up
    const [_state, setState] = useState<any>({value: ''})
    const [width, setWidth] = useState<number>(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    window.onpopstate = (e) => {
        history.push('/step')
        getBackStep(getDeviceId(), data).then((response) => {
            setData(() => response.data)
            setState({value: ''})
            console.info(`handleBack() =>: ${JSON.stringify(response.data)}`)
        })
    }
    const getCurrentStep = async () => {
        const deviceId: any = getDeviceId()
        const resp = await _getCurrentStep(deviceId, data)
        setData(() => {
            return resp.data
        })
        await checkForceUserLogin((resp.data && resp.data.data && resp.data.data.force_user_login) || false)
        console.log(`getCurrentStep() => \n${JSON.stringify(resp.data)}`)
    }

    const checkForceUserLogin = async (value: boolean) => {
        if (value) {
            console.log('Forcing user to login')
            sessionStorage.setItem('token', '')
            sessionStorage.setItem('expires', '')
            history.push('/welcome')
        }
    }

    useEffect(() => {
        getCurrentStep()
    }, [])

    useEffect(() => {
        let filter = data?.data?.body?.elements.filter(item => item.required && item.tag === "textbox")
        let disabled = filter ? !!filter.find(item => item.value.length <= 0) : false

        let filterDropdown = data?.data?.body?.elements.filter(item => item.required && item.tag === "dropdown")

        let disabledDropdown = filterDropdown ? !!filterDropdown.find(item => {
            let foundOption = item.options.find(opt => opt.selected & opt.value === null)
            return !!foundOption
        }) : false

        console.log(filterDropdown, disabledDropdown)
        setValid((!disabled && !disabledDropdown))
    }, [data]);

    const generateElement = (elementData: any, style: string): JSX.Element => {
        const type =
            elementData.tag !== undefined ? elementData.tag : elementData.format
        let element: JSX.Element = <React.Fragment></React.Fragment>

        switch (type) {
            case 'img':
                element = img(elementData, style)
                break
            case 'p':
                element = p(elementData, style)
                break
            case 'html':
                element = div(elementData, style)
                break
            case 'i':
                element = i(elementData, style)
                break
            case 'b':
                element = b(elementData, style)
                break
            case 'button':
                element = buttons(elementData, classes.answerButton, handleSubmit)
                break
            case 'dropdown':
                element = dropdown2(elementData, classes.answerButton)
                break
            case 'textbox':
                element = textBox(elementData, style)
                break
            case 'list':
                element = list(elementData, style)
                break
            case 'link':
                element = link(elementData, classes.Link)
        }
        return element
    }

    const link = (data: any, style: string = '') => {
        return (
            <a href={data.href} target='_blank' className={style}>
                {data.text}
            </a>
        )
    }

    const img = (data: IImage, style: string = '') => {
        // TODO add style prop
        let isSuha = false
        if (data.src.includes('bot')) {
            isSuha = true
        }
        return (
            <Box textAlign={'center'}>
                <img src={data.src} alt={data.text} style={{
                    height: isSuha ? null : isMobile ? null : 'calc( 100vh - 450px )',
                    width: isSuha ? 150 : isMobile ? '100%' : null
                }}/>
            </Box>
        )
    }

    const div = (data: Ip, style: string = '') => {
        return <div style={{'white-space': 'normal', 'font-size': 15}} dangerouslySetInnerHTML={{
            __html:
                data.text.replaceAll("181", "101")
                    .replaceAll('margin-bottom: 20px', 'margin-bottom: 10px')
                    .replaceAll('font-weight: bold', 'font-weight: bold; margin: 0px')
                    .replaceAll('padding: 5px 41px', 'padding: 0px 10px 0px 40px')
                    .replaceAll('padding: 30px 10px 30px 30px', 'padding: 10px 10px 10px 30px')
        }}></div>
    }
    const p = (data: Ip, style: string = '') => {
        return <span className={classes.text}>{data.text}</span>
    }

    const b = (data: Ip, style: string = '') => {
        return <b className={classes.bold}>{data.text}</b>
    }

    const i = (data: Ip, style: string = '') => {
        return <i className={classes.italic}>{data.text}</i>
    }

    const textBox = (data: ITextbox, style: string = '') => {
        return (
            <Box>
                {data.required && <i style={{float: "right", color: "#f77d7d"}}>required</i>}
                <BootstrapInput
                    multiline
                    rows={4}
                    rowsMax={10}
                    style={{width: '100%'}}
                    id={data.id}
                    placeholder={'Answer'}
                    defaultValue={data.value}
                    className={(classes.text, classes.fullWidth, style)}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {


                        if (data.required) {
                            setValid(e.currentTarget.value.length > 0)
                        }
                        data.value = e.currentTarget.value
                    }}/>
            </Box>
        )
    }

    interface IListItem {
        format: string
        text: string
        style: string
    }

    const list = (data: any, style: string = ''): JSX.Element => {
        data = data.items
        if (!data?.length) return <React.Fragment></React.Fragment>
        const items = data.map((item: any) => {
            return <li>{generateElements(item, true)}</li>
        })

        return (
            <Box>
                <ul key={1234}>{items}</ul>
            </Box>
        )
    }

    const dropdown = (data: IDropdown, style: string = '') => {
        return (
            <Box mt={4}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">Select</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={_state.value || data.options.filter(option => option.selected === true)[0].value}
                    >
                        {data.options.map((item) => {
                            return (
                                <MenuItem
                                    key={item.order}
                                    value={item.value}
                                    onClick={() => {
                                        item.selected = true
                                        data.options.map(other => {
                                            if (other.value !== item.value) other.selected = false
                                            return other
                                        })
                                        setState({value: item.value})
                                    }}
                                >
                                    {item.title}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Box>
        )
    }

    const dropdown2 = (elementData: IDropdown, style: string = '') => {
        return (
            <>
                <span id="demo-simple-select-label" className={classes.text}>Please Select one:</span>
                {elementData.required && <i style={{float: "right", color: "#f77d7d"}}>required</i>}
                {elementData.options.filter(item => item.value != null).map((item) => {
                    return (
                        <Button
                            disableElevation
                            fullWidth={true}
                            variant="outlined"
                            color="primary"
                            key={item.order}
                            value={item.value}
                            onClick={() => {
                                item.selected = true
                                elementData.options.map(other => {
                                    if (other.value !== item.value) other.selected = false
                                    return other
                                })
                                let filterDropdown = data?.data?.body?.elements.filter(item => item.required && item.tag === "dropdown")

                                let disabledDropdown = filterDropdown ? !!filterDropdown.find(item => {
                                    let foundOption = item.options.find(opt => opt.selected & opt.value === null)
                                    return !!foundOption
                                }) : false

                                setValid((!disabledDropdown))
                                setState({value: item.value})
                            }}
                            className={_state.value === item.value || elementData.options.filter(option => option.selected === true)[0].value === item.value ? classes.selectedButton : classes.unselected}
                        >
                            {item.title}
                        </Button>
                    )
                })}
            </>
        )
    }
    const buttons = (value: IButtons, style: string = '', handleSubmit: any) => {
        const generatedButtons = value.buttons.map(
            (button: IButton, idx: number) => {
                return (
                    <Button
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className={style}
                        key={idx}
                        onClick={(e) => {
                            button.selected = true
                            setData({...data, ...button})
                            handleSubmit()
                        }}
                        disabled={loading}
                    >
                        {button.title}
                    </Button>
                )
            }
        )
        return (
            <Grid
                xs={12}
                item
                spacing={2}
            >
                {generatedButtons}
            </Grid>
        )
    }

    const handleSubmit = async () => {
        console.info('Submitting')
        setLoading(true)
        await processCurrentStep(getDeviceId(), data).then((response) => {
            setData(() => response.data)
            setState({value: ''})
            setLoading(false)
            checkForceUserLogin((response.data && response.data.data && response.data.data.force_user_login) || false)
        })
    }
    const handleBack = async () => {
        console.info('Back')
        await getBackStep(getDeviceId(), data).then((response) => {
            setData(() => response.data)
            setState({value: ''})
            console.info(`handleBack() =>: ${JSON.stringify(response.data)}`)
        })
    }

    const generateElements = (data: any, raw = false) => {
        if (data?.length) {
            let elements: any = []
            data.map((item: any, idx: number) => {
                if (item.format === "p") {
                    let paragraph = item.text.split(/\n|\\n/)
                    let newData = []
                    if (paragraph.length > 1) {
                        for (let j = 0; j < paragraph.length; j++) {
                            newData.push(' ' + paragraph[j])
                            newData.push(<br key={"inner" + i + '-' + j}/>)
                        }
                    } else {
                        newData.push(' ' + item.text)
                    }

                    elements.push(<React.Fragment key={idx}>{newData}</React.Fragment>)
                } else {
                    let elem: JSX.Element = generateElement(item, '')
                    const type = item.tag || item.format
                    if (['i', 'b', 'p', 'link', 'html'].includes(type) || raw === true) {
                        elements.push(<React.Fragment key={idx}>{elem}</React.Fragment>)
                    } else {
                        elements.push(<Grid key={idx} item xs={12}>
                            {elem}
                        </Grid>)
                    }
                }
            })
            return elements
        }
        return <Grid item></Grid>
    }

    /*
    let paragraph = item.text.split(/\n|\\n/)
                  let newData = []
                  if (paragraph.length > 1) {
                      for (let j = 0; j < paragraph.length; j++) {
                          newData.push(' ' + paragraph[j])
                          newData.push(<br key={"inner" + i + '-' + j}/>)
                      }
                  } else {
                      newData.push(' ' + response.text)
                  }

                  data.push(<span key={i}>{newData}
                  </span>)
     */
    const generateNextButton = (data: any, show: boolean = false, elements: any) => {
        if (!show) return <React.Fragment></React.Fragment>

        return <React.Fragment>
            <div className={classes.buttons}>
                {submitbuttons(data, classes.nextButton, handleSubmit)}
            </div>
        </React.Fragment>
    }

    const submitbuttons = (value: IButtons, style: string = '', handleSubmit: any) => {

        const generatedButtons = value.buttons.map(
            (button: IButton, idx: number) => {
                return (
                    <Button
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className={style}
                        key={idx}
                        onClick={(e) => {
                            button.selected = true
                            setData({...data, ...button})
                            handleSubmit()
                        }}
                        disabled={loading || !valid}
                    >
                        {button.title}
                    </Button>
                )
            }
        )
        return (
            <Grid
                xs={12}
                item
                spacing={2}
            >
                {generatedButtons}
            </Grid>
        )
    }

    return (
        <Box p={1} className={classes.root}>
            <Backdrop
                style={{zIndex: 100}}
                sx={(theme) => ({ color: '#fff', zIndex: 100 })}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box alignContent={'flex-start'} pt={2}>
                {data?.data?.show_back_button ? (
                    <Grid container alignContent={"center"} alignItems={"center"}>
                        <Grid item xs={3} alignItems={'flex-start'} justifyContent={'flex-start'}
                              justify={'flex-start'}>
                            <ChevronLeftIcon
                                onClick={handleBack}
                                className={classes.backButton}
                            ></ChevronLeftIcon>
                        </Grid>
                        {/*<Grid item xs={9}>*/}
                        {/*    <SuhaBubble/>*/}
                        {/*</Grid>*/}
                    </Grid>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
            </Box>
            <Grid
                container
                justify={'center'}
                justifyContent={'center'}
                alignItems={'center'}
                alignContent={'center'}
                className={classes.container}
            >
                <Grid item sm={7} xs={12} style={{minHeight: 400}}>
                    <div className={classes.text}>
                        {generateElements(data?.data?.body.elements)}
                    </div>
                </Grid>
                <Grid item sm={7} xs={12}>
                    {generateNextButton(
                        data?.data?.next_button,
                        data?.data?.show_next_button,
                        data?.data?.body.elements
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}
